import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ClientPrivateRoute = ({ children }) => {
  const globalState = useSelector((state) => state.clientReducer);
  const navigate = useNavigate();

  useEffect(() => {
    if (!globalState?.isClientLoggedIn) {
      navigate("/client-login");
    }
  }, [globalState?.isClientLoggedIn, navigate]);

  return globalState?.isClientLoggedIn ? children : null;
};

export default ClientPrivateRoute;
